import Icon from '@ant-design/icons'

const SVG = () => (
    <svg
        t='1661313240891'
        className='icon'
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        p-id='17452'
    >
        <path
            d='M823.5 102.1H177.2c-36.6 0-66.3 29.7-66.3 66.3v699.2c0 36.6 29.7 66.3 66.3 66.3h646.3c36.6 0 66.3-29.7 66.3-66.3V168.4c0-36.5-29.7-66.3-66.3-66.3z m-3.7 761.8H180.9V172.1h638.9v691.8z'
            p-id='17453'
            fill='currentColor'
        ></path>
        <path
            d='M419.9 381l95.4 87.4L700 299.3l-47.3-51.6-137.4 125.8-95.4-87.4-119.1 109.1 47.3 51.6zM430.5 639.7c0 10.3-0.4 21.2-1.3 32.5-0.9 11.1-2.8 22.4-5.6 33.6-2.8 11-7.2 21.8-13 32-5.8 10.1-13.7 19.5-23.6 27.9l-5.2 4.4 5.8 3.6c2.2 1.4 4.9 3.4 8 6.1 3.2 2.8 6.3 5.7 9.3 8.7 2.9 3 5.2 5.5 6.8 7.6l3.2 4.2 4-3.4c13.1-11.1 23.7-24.3 31.3-39.1 6.9-13.4 12.2-27.5 15.8-41.8h108.6v34.8c0 1.6-0.3 2.3-0.3 2.5-0.3 0.1-1.2 0.4-3.4 0.4-2.1 0-5.7 0-11 0.1-5.1 0-11 0-17.7-0.1-6.6-0.1-13.1-0.4-19.5-0.7l-9.2-0.5 4.5 8c2.5 4.4 5.1 9.9 7.8 16.4 2.7 6.4 4.5 11.9 5.4 16.4l0.8 4h4.1c14.2 0 26.4-0.3 36.4-1 10.4-0.7 19.3-2.6 26.3-5.7 7.4-3.2 12.8-8.1 15.9-14.4 3-6 4.4-14.1 4.4-24.8V544.5H430.5v95.2z m43.8-53.5h100.1v23.5H474.3v-23.5z m-0.7 76.2c0.2-3.9 0.4-7.8 0.5-11.7h100.3v23.5H472.9c0.3-3.9 0.5-7.8 0.7-11.8z'
            p-id='17454'
            fill='currentColor'
        ></path>
    </svg>
)

export const MonthlyIcon = props => <Icon component={SVG} {...props} />
